/* Landings del restyling. Se carga solo desde las sections que lo usan. */

/** Botón para pausar los vídeos en bucle (WCAG 2.2.2); con movimiento reducido arrancan pausados. */
if (!window.__wimVideoToggleBound) {
  window.__wimVideoToggleBound = true;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const videosOf = (button) => Array.from(button.closest("[data-wim-video-scope]")?.querySelectorAll("video") ?? []);
  const sync = (button, playing) => {
    button.setAttribute("aria-pressed", String(!playing));
    button.setAttribute("aria-label", playing ? button.dataset.labelPause : button.dataset.labelPlay);
  };

  document.querySelectorAll("[data-wim-video-toggle]").forEach((button) => {
    if (reduced) videosOf(button).forEach((video) => video.pause());
    sync(button, !reduced);
  });

  document.addEventListener("click", (event) => {
    const button = event.target.closest("[data-wim-video-toggle]");
    if (!button) return;
    const videos = videosOf(button);
    const playing = videos.some((video) => !video.paused);
    videos.forEach((video) => (playing ? video.pause() : video.play().catch(() => {})));
    sync(button, !playing);
  });
}
